import { arrayToObjectMap, mapKeysToValues } from "../../../../utils"

export const leadCategoriesTransformer = response => {
  const categoryMap = arrayToObjectMap(response, "key")
  const categoryKeyToIdMap = mapKeysToValues(response)

  return { categoryMap, categoryKeyToIdMap, categories: response }
}
